export class CharacterizeTestedPartyFunctionsPerformedErrorResponse {
  characterizationFunctionsPerformed: any;
}
